import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import {Language, languageToLocale} from "./Language";

export class DateTimeSubsystemConfigurer {
    private constructor() {}

    static initializeDateTimeSubsystem() {
        dayjs.extend(utc);
        dayjs.extend(customParseFormat);
        dayjs.extend(localizedFormat);
    }

    static setLocaleByLanguage(language: Language) {
        const dayjsLocale = languageToLocale(language);
        dayjs.locale(dayjsLocale);
    }
}